export function SupportPage() {
  return (
    <section>
      <header className="page-head">
        <div>
          <p className="eyebrow">Aide</p>
          <h1>Support</h1>
          <p className="lede">Le chemin d'une vidéo, du panneau jusqu'à la télé.</p>
        </div>
      </header>
      <article className="card contact-card">
        <div>
          <p className="eyebrow">Contact</p>
          <h2>Rémi Penot</h2>
          <p className="muted">Une télé noire, un code qui ne colle pas, ou une question.</p>
        </div>
        <a className="button primary" href="mailto:remi@penot.ca">Écrire à remi@penot.ca</a>
      </article>
      <ol className="steps">
        <li className="step">
          <span className="step-n">1</span>
          <div>
            <h2>Créer l'écran</h2>
            <p>Dans Écrans, donnez un nom à la télé, par exemple Cardio ou Accueil. Copiez son lien : chaque télé a le sien.</p>
          </div>
        </li>
        <li className="step">
          <span className="step-n">2</span>
          <div>
            <h2>Coller le lien dans la box</h2>
            <p>Dans Vitrine Signage Player, Fully Kiosk ou le navigateur Android TV, ce lien est la page de démarrage, en plein écran.</p>
          </div>
        </li>
        <li className="step">
          <span className="step-n">3</span>
          <div>
            <h2>Autoriser le code</h2>
            <p>La télé montre un code à 6 chiffres. Rien ne joue tant qu'il n'est pas accepté dans Autorisations. Comparez le code et l'adresse IP avec la télé du club.</p>
            <p>Refuser, ou Retirer l'accès plus tard, coupe la lecture. Supprimer efface ensuite une autorisation déjà refusée. Si la télé est encore ouverte, elle affiche un nouveau code.</p>
          </div>
        </li>
        <li className="step">
          <span className="step-n">4</span>
          <div>
            <h2>Envoyer les médias</h2>
            <p>Dans Médias, déposez une vidéo MP4 ou une image JPEG, PNG, WebP ou GIF. Le fichier entre dans une playlist quand l'envoi est terminé.</p>
          </div>
        </li>
        <li className="step">
          <span className="step-n">5</span>
          <div>
            <h2>Monter la playlist et l'assigner</h2>
            <p>Dans Playlists, ajoutez les médias dans l'ordre de passage. Pour une image, indiquez les secondes. Pour une vidéo, laissez le champ vide pour la jouer en entier.</p>
            <p>Ouvrez ensuite l'écran, choisissez la playlist, puis Enregistrer. Le son est coupé par défaut. Cochez Son seulement si cette télé doit l'entendre.</p>
          </div>
        </li>
        <li className="step">
          <span className="step-n">6</span>
          <div>
            <h2>Si la télé ne suit pas</h2>
            <p>Relancer lui demande de recharger d'ici une trentaine de secondes. En lecture : une télé autorisée a demandé sa playlist récemment. En attente : un code n'est pas encore accepté. Hors ligne : aucune télé autorisée n'a répondu depuis un moment.</p>
            <p>Si ce silence dure dix minutes, Accueil et Écrans signalent la télé. Un simple redémarrage ne déclenche pas cette alerte.</p>
          </div>
        </li>
      </ol>
    </section>
  );
}
